export const MTM_GET_INIT = 'MTM_GET_INIT';
export const MTM_GET_SUCCESS = 'MTM_GET_SUCCESS';
export const MTM_GET_ERROR = 'MTM_GET_ERROR';
export const MTM_CHANGE_FLAG = 'MTM_CHANGE_FLAG';
